export default __webpack_public_path__ + "static/Cover-ddde27e7eef5928db6bf905f2f3c7278.jpeg";